import React from 'react';

interface ConfirmDeleteModalProps {
  title?: string;
  message?: string;
  itemName?: string;
  onConfirm: () => void;
  isLoading?: boolean;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  title = "Confirm Delete",
  message,
  itemName,
  onConfirm,
  isLoading = false
}) => {
  const defaultMessage = itemName 
    ? `Are you sure you want to delete "${itemName}"? This action cannot be undone.`
    : "Are you sure you want to delete this item? This action cannot be undone.";

  return (
    <div className="modal fade" id="confirmDeleteModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-danger">
              <i className="ti ti-alert-triangle me-2"></i>
              {title}
            </h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div className="modal-body">
            <div className="alert alert-danger">
              <i className="ti ti-alert-triangle me-2"></i>
              {message || defaultMessage}
            </div>
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-cancel" 
              data-bs-dismiss="modal"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button 
              type="button" 
              className="btn btn-danger" 
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Deleting...
                </>
              ) : (
                <>
                  <i className="ti ti-trash me-2"></i>
                  Delete
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
